export const phoneMask = (value) => {
  if (!value) return '';
  // Remove tudo que não for dígito
  let digits = value.replace(/\D/g, '');
  // Limita a 11 dígitos (DDD + 9 números)
  digits = digits.substring(0, 11);

  if (digits.length <= 2) {
    return `(${digits}`;
  }
  if (digits.length <= 6) { // até DDD + 4 números
    return `(${digits.substring(0,2)}) ${digits.substring(2)}`;
  }
  if (digits.length <= 10) { // formato fixo (DDD) XXXX-XXXX
    return `(${digits.substring(0,2)}) ${digits.substring(2,6)}-${digits.substring(6)}`;
  }
  // formato celular (DDD) XXXXX-XXXX (11 dígitos)
  return `(${digits.substring(0,2)}) ${digits.substring(2,7)}-${digits.substring(7)}`;
};

export default phoneMask;